import { PropType } from '@vue/composition-api';
import { AdgroupFormData } from '@tt4b/ttam-enums';

export const props = {
  adgroupData: {
    type: Object as PropType<AdgroupFormData>,
    required: true,
  },
  nodeData: {
    type: Object,
    default: () => ({}),
  },
  placement: {
    type: String,
    default: 'top',
  },
  /** interest / video / creator / inMarket */
  type: { type: String, default: 'interest' },
  /** 文案的 key */
  label: { type: String, default: 'label' },
  showInterestClass: { type: Boolean, default: false },
  isShowDescription: { type: Boolean, default: true },
  isFiveInOneNewVersion: { type: Boolean, default: false },
};
